import React from "react";
import "./css/adjustable_payment_table.css";
import CurrencyField from "../../fields/currency_field";
import NumberField from "../../fields/number_field";
import { useDocument } from "../loan_tool";
import {
  first_mortgage_payment_p_and_i,
  loan_amount_first_mortgage,
  loan_term_in_years
} from "../../../calculations/loan";
import {
  buydown_year_payment,
  buydown_total_months,
  buydown_change_payments
} from "../../../calculations/buydown";

// Step Payment ("Payment Option") disclosure — the note rate is fixed; only the
// payment steps up for the first N years. Mirrors the interest-only AP table layout.
export default function BuydownApTable({ loan }) {
  const [
    { property, property_to_be_sold, is_selling_property },
    ,
    { documentType }
  ] = useDocument();

  const loanAmount = loan_amount_first_mortgage(
    documentType,
    loan,
    property,
    property_to_be_sold,
    is_selling_property
  );
  const termMonths = loan_term_in_years(loan).mul(12);
  const changes = buydown_change_payments(loan);
  const firstChange = changes[0];
  const subsequent = changes.slice(1);
  const lastChange = changes[changes.length - 1];
  // At the first change the payment becomes the Year-2 amount.
  const firstChangeAmount = buydown_year_payment(loan, 2, loanAmount, termMonths);
  const fullPayment = first_mortgage_payment_p_and_i(
    documentType,
    loan,
    property,
    property_to_be_sold,
    is_selling_property
  );

  return (
    <table className="adjustable-payment-table">
      <colgroup>
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <td className="summary-header">Adjustable Payment (AP) Table</td>
          <td />
        </tr>
      </tbody>
      <tbody className="with-td-border">
        <tr>
          <td>Interest Only Payments?</td>
          <td>No</td>
        </tr>
        <tr>
          <td>Optional Payments?</td>
          <td>No</td>
        </tr>
        <tr>
          <td>Step Payments?</td>
          <td>
            Yes for your first{" "}
            <NumberField naked value={buydown_total_months(loan)} /> Payments
          </td>
        </tr>
        <tr>
          <td>Seasonal Payments?</td>
          <td>No</td>
        </tr>
        <tr>
          <td colSpan="2" className="bold">
            Monthly Principal and Interest Payments.
          </td>
        </tr>
        <tr>
          <td className="no-right-border">First Change/Amount</td>
          <td className="no-left-border">
            <CurrencyField naked fixedDigits={0} value={firstChangeAmount} /> at{" "}
            <NumberField naked value={firstChange} />
            th payment
          </td>
        </tr>
        <tr>
          <td className="no-right-border">Subsequent Changes</td>
          <td className="no-left-border">
            {subsequent.length
              ? subsequent.map(n => `${n}th`).join(" & ") + " payment"
              : "No Subsequent Changes"}
          </td>
        </tr>
        <tr>
          <td className="no-right-border">Maximum Payment</td>
          <td className="no-left-border">
            <CurrencyField naked fixedDigits={0} value={fullPayment} /> Starting
            at <NumberField naked value={lastChange} />
            th Payment
          </td>
        </tr>
      </tbody>
    </table>
  );
}
